module.exports = __webpack_public_path__ + "img/newchris-62.a54a6291.jpg";